module.exports = {
  menu: {
    home: '首页',
    aboutus: '关于我们',
    productService: '产品与服务',
    learningCommonweal: '学术与公益',
    news: '动态',
    talkmateIntro: '全球说简介',
    utnIntro: 'UTN简介',
    professonalCommittee: '专业委员会',
    joinUs: '加入我们',
    talkmate: '全球说APP',
    childrenCourse: '儿童多语言启蒙',
    proCourse: '多语课程PRO',
    childrenClass: '儿童多语实验班',
    partner: '合作伙伴',
    WebResource: '服务平台',
    researchProject: '课题研究',
    langProtection: '语言保护与推广',
    langCompetition: 'Language Champion',
    download: '下载中心',
    2019: '2019',
    2018: '2018',
    2017: '2017',
    2016: '2016',
    2015: '2015'
  },
  footer: {
    icp: {
      text1: '京ICP备14044248号',
      text2: '公安部备案号 11010502036358',
      text3: '出版物经营许可证 第朝180182号',
      text4: '办学许可证 教民111010873930321号'
    },
    text1: '全球说 版权所有 @',
    text2: '使用条款 | 隐私政策 / 帮助'
  },
  home: {
    text01: '学习新语言，沟通新世界',
    text02: '加入包含全球数千种语言的免费学习社区',
    text03: '立即体验',
    text04: '联合国教科文组织',
    text05: '全球伙伴',
    text06: '苹果应用商店',
    text07: '2019语言类精选应用',
    text08: '抖音短视频',
    text09: '战略合作伙伴',
    text10: '我想学习…',
    text11: '近百种语言课程',
    text12: '收起',
    text13: '很高兴看见在联合国教科文组织的引领下全球说和腾讯云',
    text14: '结成战略伙伴，共同在人工智能AI技术研究上不断前进。',
    text15: '穆兹·查楚克（Mr Moez Chakchouk)',
    text16: '联合国教科文组织助理总干事',
    text17: '全球说独特的ICOC母语学习法，',
    text18: '帮助26所可儿幼儿园有效实现了多语言教学',
    text19: '刘可夫',
    text20: '中国可儿教育集团董事长',
    text21: '全球说是人类语言的宝藏，提供了目前世界上绝大多数语种的',
    text22: '语言课程和语言资源！',
    text23: '汪涵',
    text24: '著名主持人/联合国教科文组织-全球说世界语言地图推广大使',
    text25: '来认识一下talkmate的不同之处!',
    text26: '联合国教科文组织世界语言地图项目合作伙伴',
    text27: '',
    text28: '适合零基础的自然母语学习法',
    text29: '每一个单词和句子都有独立的ICOC模型，零基础学习，享受自然习得外语的乐趣。',
    text30: '先进的人工智能学习技术',
    text31: '由AI算法控制的跟读检测、问答、组句、自动评分和自适应测评，极致提升学习体验。',
    text32: '遍布世界的学习语伴',
    text33: '为你提供沉浸式的外语学习环境；进入社区，和他们交换语言学习，畅聊国家文化，分享日常语言学习趣事。',
    text34: '立体互动的学习场景',
    text35: '移动应用、网站系统、图书教材组成立体学习场景，同时满足碎片时间自学、传统课堂教学需求。',
    text36: '学习即公益',
    text37: '成为世界语言地图的一员，你的学习和关注都是最棒的语言保护。',
    text38: '来了解一下talkmate的非凡之处！',
    text39: '万个',
    text40: '原创教材文字',
    text41: '教材母语发音',
    text42: '正版教材配图',
    text43: '人工智能标签',
    text44: '语言课程',
    text45: '通过完整的学习系统，努力实现全世界其他国家官方语言的课程制作，目前已经完成了50%*！',
    text46: '全球语伴',
    text47: '每一位用户都会得到精准推荐，匹配合适的语伴！',
    text48: '语言资源',
    text49: '在这里我们正在收录更多的人类语言资源提供给语言学习者和研究者。',
    text50: '进入世界语言地图',
    text51: '人们都在谈论talkmate',
    text52: '移动应用，随时随地随心自学！',
    text53: '除了在笔记本电脑上学习外，手机学习也非常方便！',
    text54: '充分使用移动应用中的“离线下载”功能，即使没有手机信号你也可以随时随地自由学习。',
    text55: '联合国',
    text56: '2019 国际本土语言年全球伙伴',
    text57: '中国语言资源',
    text58: '保护与研究中心战略合作伙伴',
    text59: '苹果应用商店',
    text60: '2019语言类精选应用',
    text61: '腾讯云',
    text62: 'AI全球战略伙伴',
    text63: '新浪微博',
    text64: '战略合作伙伴',
    text65: '抖音短视频'
  },
  about: {
    talkmateIntro: {
      text01: '联合国教科文组织《世界语言地图》官方项目合作平台全球说，拥有约7000多种语言的语言信息。基于自主研发的课程体系与语音识别技术的全面结合，全球说APP提供近八十种语言的系统课程，帮助语言学习者以零基础掌握不同语言。',
      text02: '多语言教育',
      text03: '《世界语言地图》肩负倡议、引领、促进、普及、保护世界语言多样性的重要职责。2016年6月，联合国教科文组织与全球说正式签订伙伴协议并组建联合项目办公室（UNESCO-TALKMATE NEXUS，简称：UTN），通过升级教科文组织现有的“世界濒危语言计划”至“世界语言地图”项目，促进各国以母语为基础的多语言教育，推动语言多样性的发展，从根本上实现联合国《2030年可持续发展议程》',
      text04: '全球说拥有目前世界上绝大多数语种的',
      text05: '语言资源',
      text06: '，涵盖人类数千种语言，是联合国教科文组织世界语言地图的应用承载平台。',
      text07: '全球说提供近百种完整的',
      text08: '语言课程',
      text09: '，可以满足学生在线自学，以及教师线下教学需要。',
      text10: '全球说完全自主研发的语音识别与人工智能',
      text11: '学习技术',
      text12: '，持有超过1000余项技术与内容方面的知识产权，成为世界多语言教育标准的主要制定者之一。',
      text13: '全球说的重要荣誉包括 ——',
      text14: '联合国教科文组织',
      text15: '全球伙伴',
      text16: '中国国家语言文字工作委员会',
      text17: '官方合作伙伴',
      text18: '中华人民共和国教育部',
      text19: '最佳合作伙伴',
      text20: '全球未来教育协会',
      text21: '多语言课程标准委员会主席',
      text22: '欧敏行 博士 (Dr. Marielza Oliveira)',
      text23: '联合国教科文组织知识社会处处长',
      text24: '“UNESCO向来重视世界语言和文化的传承，语言是帮助解答‘我们是谁’的钥匙，与人类内心最深处的身份认同息息相关。我们十分荣幸与全球说一起携手，让每一种语言都可听、可见、可学、可用，运用信息科学技术连接语言的应用、传承和保护。”',
      text25: '全球说与联合国教科文组织的关系 ——',
      text26: '世界语言地图项目是由联合国教科文组织负责推动的全球性 “语言遗产类”保护项目。',
      text27: '2001年11月，联合国教科文组织第31届大会在巴黎总部通过了《世界文化多样性宣言》，把文化多样性和语言多样性视为“人类共同的遗产”。',
      text28: '2014年2月，联合国教科文组织发表了一份战略文件，说明为推出新的世界语言地图应采取的步骤，文件明确提出了拟扩大全球伙伴关系并将专家们提出的建议转化为国家和地区具体行动的计划。',
      text29: '2016年7月8日，联合国教科文组织与全球说联合新闻发布会，凯宾斯基饭店，中国北京',
      text30: '2016年7月，全球说（talkmate）被遴选成为联合国教科文组织语言类基石伙伴企业（Joint Partnership），并正式签订战略合作协议，展开为期10年的工作计划，共同建设世界语言地图。由联合国教科文组织与全球说建立联合工作组（UNESCO-TALKMATE NEXUS），升级其现有的世界语言地图平台，使这一项目具备交互性、可协作性与开放性，提升国家和地区组织之间分享语言知识的能力，并推动保护语言多样性、促进以母语教育为基础的多语言教育，从根本上实现联合国《2030年可持续发展目标》议程。',
      text31: '2018年2月23日，联合国教科文组织-全球说联合新闻发布会，联合国教科文组织总部，法国巴黎',
      text32: '2018年2月，联合国教科文组织与全球说（talkmate）再次签订补充协议，并就全面深化合作伙伴关系在法国巴黎教科文总部正式举行发布会。双方在现有世界语言地图合作项目基础上，将共同携手推进联合国“2019国际本土语言年（2019 International Year of Indigenous Languages）”，并通过对多语言教育的推广和多元文化的应用，提升全球公民意识，推动世界公民的培养。联合国教科文组织副总干事格塔丘•安吉达(Getachew Engida)、助理总干事埃里克• 福尔特(Eric Falt)、知识社会局局长班纳吉博士、世界语言地图项目负责人布德博格博士，中国常驻联合国教科文组织大使衔代表沈阳超过55个国家驻教科文组织的常驻团代表大使也出席了发布会。',
      text33: '图说全球说 ——',
      text34: '领导关怀',
      text35: '联合国教科文组织第38届大会主席斯坦利-西马塔视察全球说',
      text36: '教育部副部长沈晓明向全球说颁发"中国教育部最佳合作伙伴"荣誉',
      text37: '教育部副部长、国家语委主任杜占元陪同外宾体验全球说课程',
      text38: '教育部副部长、孔子学院总部常务理事郝平视察世界语言地图项目',
      text39: '中国教育部语言文字信息管理司、语言文字应用管理司司长田立新莅临考察指导工作',
      text40: '法国文化部法语总司司长罗伊克·德佩克先生参观考察世界语言地图',
      text41: '美国百名中小学校长访华团体验全球说多语智能学习系统',
      text42: '中国政协常委、中宣部原副部长胡振民莅临考察指导工作',
      text43: '中国人民对外友好协会 秘书长 李希奎莅临考察指导工作',
      text44: '汇聚力量',
      text45: '著名主持人汪涵受聘为联合国教科文组织-全球说推广人',
      text46: '北京语言大学副校长曹志耘教授代表中国语保资源中心与全球说签订战略合作伙伴协议',
      text47: '中华人民共和国前驻纽约总领事邱胜云先生受聘担任世界语言地图项目顾问',
      text48: '全球说与北京联合国教科文组织协会签订战略合作伙伴协议',
      text49: '联合国教科文组织东北亚总代表欧敏行博士助力世界语言地图项目',
      text50: '联合国教科文组织项目主管英伽达博士助力世界语言地图项目',
      text51: '哥伦比亚驻华大使Salamanca助力世界语言地图项目',
      text52: '阿尔及利亚驻华大使Boukhelfa助力世界语言地图项目',
      text53: '喀麦隆驻华大使Martin助力世界语言地图项目',
      text54: '联合国教科文组织全民信息计划（IFAP）副主席段黎萍助力世界语言地图项目',
      text55: '历史时刻',
      text56: '35国母语编辑齐聚全球说学习系统上线发布会',
      text57: '联合国教科文组织与全球说共同主办”语言与发展“圆桌会议',
      text58: '联合国教科文组织、中国语保中心与全球说共同举办“南山会讲”',
      text59: '全球说参与举办中国语言发展的里程碑事件”世界语言资源保护大会“',
      text60: '联合国教科文组织、全球说与可儿教育集团在教科文总部举办”未来小公民教育“圆桌会议',
      text61: '全球说作为中国地区唯一受邀代表出席非洲学习论坛并致辞',
      text62: '联合国教科文组织-全球说首家多语教育实验幼儿园落地中国可儿教育集团'
    },
    utntro: {
      text01: 'UNESCO-TALKMATE NEXUS（UTN）全称“联合国教科文组织-全球说”，由2016年联合国教科文组织批准的《世界语言地图纲要》所定义，是为推进世界语言地图建设的全球性行动计划。',
      text02: 'UTN的目标是通过线上及线下工作，升级现有的世界语言地图平台，使这一项目具备交互性、可协作性与开放性，提升国家和地区组织之间分享语言知识的能力，并推动保护语言多样性、促进以母语教育为基础的多语言教育，从根本上实现联合国《2030年可持续发展目标》议程。',
      text03: '业务指导单位：联合国教科文组织总部信息处',
      text04: '项目主管单位：中华人民共和国教育部教科文组织全国委员会',
      text05: '业务合作单位：联合国教科文组织总部信息处',
      text06: '相关业务网址：www.unesco.org',
      text07: '联合国教科文组织知识社会局局长班纳吉博士对项目致辞(2018年2月)',
      text08: '中国常驻联合国教科文组织大使衔代表沈阳对项目致辞(2018年2月)',
      text09: '联合国教科文组织副总干事安吉达对项目致辞(2018年2月)',
      text10: '世界语言地图25年 ——',
      text11: '世界语言地图项目是由联合国教科文组织负责推动唯一的全球性“语言遗产类”保护项目，起源于1993年教科文组织立项的“世界濒危语言计划”。',
      text12: '2001年11月2日，联合国教科文组织第31届大会在巴黎总部通过了《世界文化多样性宣言》，首次把文化多样性和语言多样性视为“人类共同的遗产”。2003年，联合国教科文组织大会又通过了《普及网络空间及促进并使用多种语言的建议书》，重点提出了加强世界语言的多样性，尤其是促进多语言在互联网上发展的倡议。此项倡议以互联网为载体，呼吁全球各界保护语言多样性，获得了各会员国广泛的支持和认同。',
      text13: '今天，“多语言即多文化”是21世纪“推动世界和平发展”的重要核心。特别是伴随着互联网信息技术的多样性发展，联合国教科文组织旨在把世界语言地图打造为一个全球互动、合作、开放的平台，希望通过加强各国政府、公众对世界语言多样性的认识，推动不同语言及文化间的平等对话、和谐共荣。',
      text14: '长远来看，世界语言地图将会有效地应用信息技术这一至关重要的教育和交流工具，对语言多样性做出贡献——通过帮助社会和机构参与教育、分享信息、提供服务及相关资源，这是一个开放的、多元的、可参与的、可持续发展的包容性知识社会中公民应有的权利；同时，也将有助于鼓励利益攸关方加强合作、提高人们对语言多样性及多语言环境重要性认识，并实现联合国2030可持续发展目标。',
      text15: '新行动计划 ——',
      text16: '2014年2月，联合国教科文组织发表了一份战略文件，说明为2019年推出新的世界语言地图应采取的步骤，文件明确提出了拟扩大全球伙伴关系并将专家们提出的建议转化为国家和地区具体行动的计划。为此，由联合国教科文组织与全球说（talkmate）',
      text17: '组建联合工作组，升级其现有的世界语言地图平台，使这一项目具备交互性、可协作性与开放性，提升国家和地区组织之间分享语言知识的能力，并推动保护语言多样性、促进以母语为基础的多语言教育，从根本上促进和实现联合国《2030年可持续发展议程》。',
      text18: '2018年2月21日第十九个“国际母语日”，联合国教科文组织与全球说（talkmate）在巴黎总部召开发布会，正式向各会员国宣布，通过多语言课程和多元文化环境建设促进世界公民的培养。即在多维度的世界语言地图平台上，通过创新性的、可扩展的信息技术支持，获取世界各地语言多样性方面的数据和资源，发展多语言教育，培养实现可持续的包容性增长以及和平共处所需的正确价值观和技能，打造通向优质和公平教育的桥梁。',
      text19: '主要工作 ——',
      text20: '—— 动员合作伙伴为世界语言地图的建立贡献力量，世界语言地图将用于语言保护、监控、推广、语言相关问题的知识和信息分享、语言教学、并提供可交互的解决办法。',
      text21: '—— 建立专业和机构能力，促进语言复兴并通过多语种的应用和协同工作完成数据建设工作。',
      text22: '—— 通过国际性的活动，提升公众对语言多样性于可持续经济、文化、技术、政治发展重要性的意识。',
      text23: '主要活动 ——',
      text24: '—| 多语言全球工作组',
      text25: '强化语言机构管理语言资源的能力，采用信息技术解决方案来扩大普及并提高语言保护的质量；在全球范围开展语言多样性教育，特别是针对偏远地区的语言学习者和残障人士。',
      text26: '—| 全球高等教育机构网络',
      text27: '强化语言机构和教育工作者记录、保存、分享语言资源的能力，构建具有互动性和包容性的学习分享环境，使得该环境有助于全球范围内的语言信息创造。',
      text28: '—| 国际顾问委员会',
      text29: '在以信息技术为基础的世界语言地图项目中成立的一个支持语言发展的专业委员会，该委员会通过包容性和互动性技术解决方案，用以识别语言，鉴定语言的活力状况，促进语言复兴。',
      text30: '布德博格 博士 ( Dr. Irmgarda Kasinskaite Buddeberg )',
      text31: '联合国教科文组织信息与传播部门专家，世界语言地图项目负责人',
      text32: '“联合国教科文组织与全球说（talkmate）一直致力于促进语言多样性和文化多样性的发展。从长远来看，双方坚实的合作伙伴关系将进一步为世界构建一个全面的、可持续的多语言及多文化交互式资源平台，促进多语言环境和多元文化在全球的保护及推广。”'
    },
    proCommittee: {
      text01: '—— 学术委员会 ——',
      text02: '联合国教科文组织-全球说',
      text03: '学术委员会 召集人',
      text04: '安德鲁·陶西格博士',
      text05: '联合国教科文组织高级顾问，牛津大学研究员，国际信息传播研究所董事，日内瓦信息社会世界首脑会议英国委员会成员；安德鲁博士为英国广播公司（BBC）服务长达三十年，历任新闻时事部主任、欧洲总监及全球语言事务局局长，是英国广播公司出版编辑和制作指南的奠基人。',
      text06: '联合国教科文组织-全球说',
      text07: '学术委员会 主席',
      text08: '迪特尔教授',
      text09: '迪特尔教授是全球社会语言学权威学者，联合国教科文组织高级顾问，奥地利格拉茨大学多元语言研究中心主任，欧盟议会少数民族语言宪章委员会成员，罗马尼亚国家语言与文化发展协调人。',
      text10: '联合国教科文组织-全球说',
      text11: '学术委员会 首席专家',
      text12: '王莉宁教授',
      text13: '王教授是“中国语言资源保护工程”核心专家，“中国语言资源保护工程”核心专家。北京语言大学教授。博士生导师，应用语言学博士。入选北京市第八批优秀青年人才（2016）。合著《汉语方言地图集》曾获中国高等学校科学研究优秀成果奖（人文社会科学）一等奖。',
      text14: '—— 推广大使 ——',
      text15: '汪涵',
      text16: '著名媒体主持人/制片人',
      text17: '響應计划发起人',
      text18: '联合国教科文组织-全球说世界语言地图推广大使',
      text19: '—— 顾问委员会 ——',
      text20: '张宇杰',
      text21: '原国家外国专家局 常务副局长',
      text22: '中国民营科技促进会高端人才',
      text23: '工作委员会顾问',
      text24: '曹志耘',
      text25: '中国语言资源保护研究中心主任',
      text26: '浙江师范大学教授、博导',
      text27: '原北京语言大学副校长',
      text28: '《语言教学与研究》杂志主编',
      text29: '中国社会语言学会会长。',
      text30: '宋立军',
      text31: '北京联合国教科文组织协会主席',
      text32: '原北京市教委国际合作交流处处长',
      text33: '港澳台侨办公室主任',
      text34: '邱胜云',
      text35: '中华人民共和国驻约旦大使',
      text36: '中华人民共和国驻纽约总领馆总领事',
      text37: '前外交学会副会长',
      text38: 'Dr. Jorge Torres-Pereira',
      text39: '葡萄牙驻华大使',
      text40: '陈建成',
      text41: '天空宽频电视台台长',
      text42: 'Martin MPANA',
      text43: '喀麦隆驻华大使',
      text44: 'Mathias Lafolie',
      text45: '瑞典驻华大使',
      text46: 'Natalia Popczyk',
      text47: '波兰驻华大使',
      text48: 'Ina Marciulionyte',
      text49: '立陶宛驻华大使',
      text50: 'Arnold Obermayr',
      text51: '欧盟文化中心合作组织主席',
      text52: 'Sandra Salamanca',
      text53: '哥伦比亚驻华大使',
      text54: 'Ahcene Boukhelfa',
      text55: '阿尔及利亚驻华大使',
      text56: '段黎萍',
      text57: '联合国教科文组织全民信息计划（IFAP）副主席'
    },
    joinUs: {
      text01: '在这里，成为理想的自己！',
      text02: '我们正在寻找可以并肩作战的伙伴。在这里，团队中的每一名成员都有充分发挥潜能的机会，每个人的意见也都将获得尊重。我们诚邀您加入全球说！',
      text03: '招聘职位',
      text04: '商务经理  北京',
      text05: '工作内容',
      text06: '1. 根据公司在KID产品上的整体商务合作政策，制定幼儿园/培训机构的开发策略，洽谈同幼儿园/培训机构的合作业务，对商务合作的任务指标负责；',
      text07: '2. 独立完成商务谈判，维护商务合作关系，对整个商务合作的过程和结果负责，并按照合作项目计划及进度执行；',
      text08: '3. 维护公司既有合作资源及商务伙伴关系，并对已有资源深度挖掘新的合作模式；',
      text09: '4. 拓展业内各类新的公共关系及客户资源，开拓业务渠道和行业系统客户，完成新客户的评估、谈判、签约等工作；',
      text10: '5.收集市场信息、产品信息、竞品信息，及时提供市场反馈为全球说发展提供依据。',
      text11: '任职要求',
      text12: '1. 本科及以上学历，市场营销、传媒、公共关系、新闻等相关专业不限；',
      text13: '2. 三年以上在教育行业从事渠道拓展或商务营销的工作经验，有幼儿教育或儿童英语培训行业经验者优先；',
      text14: '3. 熟悉资源置换/分成合作模式，有一定的渠道及合作方资源积累；',
      text15: '4. 具有较强的学习能力、沟通协调能力、谈判技巧，并具备独立开展业务拓展的能力；',
      text16: '5. 对北京周边幼教市场有一定认识，了解同行业发展，行业竞争状况，热爱教育行业；',
      text17: '6. 较强的英文听说读写能力。',
      text18: '如果你对该职位感兴趣，请将简历发送至：',
      text19: 'hr@talkmate.com',
      text20: '英语教研员  北京',
      text21: '1. 负责3-6岁儿童教材的教研，包括标准课件和教案等内容；',
      text22: '2. 设计并制作教材的配套资料，如教具、绘本等；',
      text23: '3. 负责对设计的课程进行跟踪、调研、反馈和后续优化升级，负责研究并制定教学目标相关的教学材料，包括每课教案教辅；',
      text24: '4. 定期进行教学培训、提升和改进教学质量；',
      text25: '5. 制作和课程相关的大纲设计、内容和相关物料，制作出符合产品以及市场需要的课程材料；',
      text26: '6. 分析客户需求，设计线上教研产品，不断改进课程内容设计，编写课程教案，支持教研中心教学体系，创新教学产品；',
      text27: '7. 负责与合作教育机构的产品对接、指导产品落地与教师培训。',
      text28: '1. 本科及以上学历，师范类、教育或心理学专业，有国外留学经验优先；',
      text29: '2. 从事过儿童多语言教育、英语教学，有设计过教案、课件；',
      text30: '3. 熟悉教学教研理论，具备出色的逻辑推理以及分析能力，具备良好的教研组织计划及培训能力、沟通技巧、学习能力、文字能力，富有团队合作精神；',
      text31: '4. 较强的语言表达能力、团队协作能力、以及思维能力，富有耐心、爱心，专注教学；擅长活动设计，英语可以作为工作语言，二语为法语或西班牙语的优先。',
      text32: '项目专员  北京',
      text33: '1. 协助处理作为UNESCO-TALKMATE NEXUS项目公共关系；',
      text34: '2. 协助建设项目协同行动者团队，做好相应协调与支持工作；',
      text35: '3. 协助制定项目阶段性目标和项目总体控制计划；',
      text36: '4. 有效协调各部门工作，独立有效地完成所负责项目的全部沟通工作；',
      text37: '5. 协助项目经理负责组织规划、管理、执行项目，并参与活动组织；',
      text38: '6. 上级主管安排的其他事务。',
      text39: '1. 全日制大学本科或以上学历，社会学、工商学科、管理学以及其他相关专业；',
      text40: '2. 大学英语六级以上，较强的文字功底；',
      text41: '3. 有1-2年项目推进工作经验，或在求学时有较多社会活动或领导经历者优先（海外留学/工作/NGO组织背景更佳）；',
      text42: '4. 诚实正直，热爱公益，有服务精神；',
      text43: '5. 沟通能力强，有团队精神与工作激情，能较好的与同事、合作方配合工作。',
      text44: '资深Go研发工程师  北京',
      text45: '1. 负责后端系统的架构设计和开发，主导技术选型、技术架构和技术风险评估；',
      text46: '2. 结合需求设计实现安全、稳定、高伸缩性、高性能、易维护的系统；',
      text47: '3. 根据系统发展，对技术架构不断调整，持续优化。',
      text48: '1. 大学本科及以上学历，计算机相关专业；',
      text49: '2. 熟练掌握 Go语言，有五年以上工作经验，三年以上Go线上项目架构、开发经验；',
      text50: '3. 有高负载、高并发架构设计、开发经验；',
      text51: '4. 熟悉MongoDB、Redis，熟悉数据库常用性能优化技术；',
      text52: '5. 具备一定的系统调优、性能调优经验，对疑难技术问题具备较强的排查能力；',
      text53: '6. 具有良好的团队合作精神和沟通能力；',
      text54: '7. 工作积极主动，态度踏实认真，有较高的职业素养。',
      text55: '高级Go工程师  北京',
      text56: '1. 负责iOS客户端整体架构和功能研发；',
      text57: '2. 参与项目框架改进、关键技术选型、技术难题攻关等工作',
      text58: '3. 持续研究和应用移动新技术，驱动业务发展。',
      text59: '1. 大学本科及以上学历，计算机相关专业；',
      text60: '2. 四年以上工作经验，有大型商业iOS应用开发经验优先；',
      text61: '3. 精通Objective-C 语言开发，对OC运行时、内存管理、线程管理非常熟悉；',
      text62: '4. 熟悉操作系统、数据结构算法、设计模式等计算机基础知识；',
      text63: '5. 丰富的iOS平台开发经验、系统架构、性能优化经验；',
      text64: '6. 具有良好的团队合作精神和沟通能力；',
      text65: '7. 工作积极主动，态度踏实认真，有较高的职业素养。',
      text66: '',
      text67: ''
    }
  },
  productService: {
    talkmate: {
      text01: '全球说',
      text02: '苹果App Store精华推荐',
      text03: '立即下载',
      text04: '和手机相比，网站学习的体验也很棒！',
      text05: '立即登录',
      text06: '去注册',
      text07: '非同一般的语言课程 ——',
      text08: '全球说语言课程基于ICOC自然母语学习法理论（raised by UNESCO-TALKMATE NEXUS）而构建。ICOC自然母语学习法基于大脑接收信息的自然方式，创造有效的外语输入，帮助学习者构建对外语语音的条件反射，形成语感，从而轻松掌握外语。成年人学习能力和记忆力都比婴儿强，一旦掌握有效的语言输入和自然习得的方式，学习外语事半功倍。',
      text09: '有效输入，用耳朵和眼睛感官接受图片和声音，建立思维闪像。',
      text10: '检查学习效果，总结给出智能的学习计划和推送内容。',
      text11: '情景代入，将学习内容和现实联系起来，增加感官印象，强化大脑中的思维闪像。',
      text12: '有效的输出，通过说和写进行模仿和使用，养成语言思维模式。',
      text13: '《WAL母语学习法白皮书》',
      text14: '零基础起步，阶梯式学习体系',
      text15: '每天一小时，未来积累夯实语言学习基础',
      text16: '游戏化设计，全程放松的学习',
      text17: '18种交互式游戏化设计，无需硬背单词和记忆语法',
      text18: '纯正的母语与丰富的各地口音',
      text19: '上千名全球语言大使带来地道的世界各地发音',
      text20: '海量的第三方拓展课程',
      text21: '数千门由第三方开发的配套拓展课程，每日更新',
      text22: '每一课新学习的单词和句子不容易记住是很正常的，无需自己去反复学习同一课，系统会根据你的记忆情况在后续学习中不断帮你复习。',
      text23: '令人惊叹的学习系统 ——',
      text24: '基于ICOC模型，全球说为语言学习构建了神奇的人工智能系统。学习系统为通过各种学习功能为每一个单词和句子设定了记忆指数增长和记忆衰退曲线控制算法：',
      text25: '通过这个统一的人工智能算法不断优化课程内容，以及由此建立的自适应学习引擎，学习系统可以根据学生在何时以及如何接触内容等数据捕获学生知识增长和减少的方式，最大程度帮助学生在200小时内掌握一门新的语言。',
      text26: '自适应发音评分与纠正',
      text27: '系统根据你的发音进步自适应调节评分参数',
      text28: '自适应学习能力测试',
      text29: '系统根据你的学习能力变化自动调整测试过程',
      text30: '自适应纠错复习',
      text31: '系统根据你学习的情况过自动创建复习模块',
      text32: '遍布全球的语伴社交 ——',
      text33: '我们的语伴遍布120多个国家，帮你提升沉浸式的外语学习环境；进入社区，发现他们的话题，阅读他们的分享。',
      text34: '看得见的进步，近百万学生持续四年的学习追踪 ——',
      text35: '坚持每天线上学习1小时，持续21天，明显建立语感！',
      text36: '坚持每天1小时，持续200天，95%的学生成功掌握一门新语言。',
      text37: '学习反馈 ——',
      text38: '全球说真是见证我的外语改变的时光机，从还没上大学开始，高三的暑假偶然发现开始使用，现在还经常会听听以前的录音，相信只要坚持，一定会有意想不到的收货！',
      text39: '一直陷在背单词背单词的噩梦当中，国内应试教育带来的伤害总也挥之不去，学了多年英语却不敢开口说话，自从在全球说进行了测评，词汇量丰富口语差的我，侧重了口语练习，已经有了显著提高！',
      text40: '想学习一门除英语外的二外，提供英语学习的渠道很多，不过小语种在线学习却没有，终于找到了全球说，解决了我这个难题，已经学习了一段时间，非常有效，进步很快！',
      text41: '-Candy',
      text42: 'Daisy_Li',
      text43: '毛球妈妈'
    },
    childCourse: {
      text01: '儿童多语言启蒙绘本（中文/英语/法语/西班牙语）',
      text02: '《全球说儿童多语课程》是联合国教科文组织世界语言地图项目唯一推荐的儿童多语言素质涵育绘本系列。',
      text03: '本课程采用联合国教科文组织与全球说共同研发的ICOC自然母语学习法教学模型，以多语绘本为主要教学线索，专为3-6岁学前儿童打造的中国首套多语学习体系，从当前儿童外语教育只关注词汇和句型的传统语言教学思维方式转变为对语感的全面培养，完整模拟了人类习得一门语言的自然过程，真正实现儿童在成长的黄金时期同时掌握第二／第三语言的可能性，符合儿童自身成长规律。',
      text04: '《全球说儿童多语课程》绘本教材共3个级别，分别为K1、K2、K3级。每级别有16本，共计48本，可与幼儿园小、中、大班教学对应匹配， 以互动性极强的阶梯式场景为基础，通过故事，单词，对话，歌曲，游戏，TPR，ROLE PALY及多元文化教学，帮助儿童建立对语言的认识，培养母语式外语学习思维方式，形成自然听、说、读的语言学习习惯，激发孩子的语言学习兴趣。将儿童培养成为拥有全球视野、掌握多种语言、理解多元文化、超越偏见并尊重多样性的未来小公民。',
      text05: '《全球说儿童多语课程》',
      text06: '课程体系',
      text07: '级别',
      text08: '词汇',
      text09: '句型',
      text10: '为保证教材的科学性与严谨性，每个级别的阅读文本均对标美国蓝思分级阅读指数。与此同时， 《全球说儿童多语课程》也在该指数的基础上结合了中国学前儿童的实际语言学习及阅读能力，对其进行了相应的本土化特征调整，使其更加适于中国儿童的语言训练场景及阅读启蒙，进一步为幼升小做好衔接准备。',
      text11: '课程结构',
      text12: '教学流程',
      text13: '教师资源',
      text14: '教师资源包：提供充足的线下教学资源，持之以恒地推行优质教育。 包括多语故事绘本教材、教案参考、教师备课笔记等，教学指导视频，DEMO课视频等。',
      text15: '在线教师管理系统：利用信息技术资源优势，有效地提高整理教育教学。包括听力、口语、阅读、语法等学习数据参考等学生学习管理数据。',
      text16: '教学视频、DEMO课、音乐、教学指导视频、电子课件等丰富教学资源。',
      text17: '教师培训支持',
      text18: '培训项目',
      text19: '内容',
      text20: '基础培训',
      text21: '开学前集训。对课程理念、体系、教材、课件、教辅、教法等进行培训，帮助老师对课程从整体上有个认知。',
      text22: '教学研讨',
      text23: '每季度周末研讨。对每个单元的课程结构、教学环节、教学目标、重难点、课堂用语、常规活动等进行研讨培训，帮助老师完成教学目标。',
      text24: 'DEMO课',
      text25: '为了让老师尽快的掌握课程的授课方式，每学期陆续录制示范教学课。',
      text26: '教学服务',
      text27: '陪伴老师身边的教研服务，借助网络与一线教师保持时时沟通和交流，及时解答老师在授课过程中遇到的各种问题，保证教学活动有质量的进行。',
      text28: '可儿幼儿园教育实践'
    },
    proCourse: {
      text01: '全球说多语课程PRO（中/英/法/西/德/日/俄）',
      text02: '《全球说多语课程PRO》是联合国教科文组织世界语言地图项目推荐，中国教育部认可的多语言教育课程。',
      text03: '本课程采用联合国教科文组织世界语言地图通用语言能力标准，通过联合国教科文组织与全球说共同研发的ICOC自然母语学习法、PRIC母语教学法和理解力算法带等原创教学模型，设计了互动性极强的阶梯式场景课程，为学生提供大量具体而真实的语言输入，能够轻松被人脑所理解。',
      text04: '《全球说多语课程PRO》课程标准是联合国教科文组织与全球说共建世界语言地图的基础设施。该课标为人类现存6000多种语言的学习与教学，提供了全新的、统一的学术框架，成为继国标ILR、美标ACTFL、欧标CEFR之后第四套世界性的通用课程标准。',
      text05: '学生用书',
      text06: '《全球说英语》样册',
      text07: '《全球说法语》样册',
      text08: '《全球说日语》样册',
      text09: '《全球说德语》样册',
      text10: '《全球说俄语》样册',
      text11: '《全球说西班牙语》样册',
      text12: '中国学校教育对标',
      text13: '《全球说多语课程PRO》契合中国学校语言教育体系，以英语课程为例，听说读写符合中国中学标准，且外语听说能力方面有着突出优势。',
      text14: '等级',
      text15: '听力',
      text16: '口语',
      text17: '语法',
      text18: '阅读',
      text19: '写作',
      text20: '词汇',
      text21: '《WAL英语》初级 A1',
      text22: '小学1-6年级',
      text23: '小学1-2年级',
      text24: '《WAL英语》初级 A2',
      text25: '初中1-3年级',
      text26: '小学3-4年级',
      text27: '《WAL英语》中级 B1',
      text28: '高中1-2年级',
      text29: '高中1年级',
      text30: '小学5-6年级',
      text31: '《WAL英语》中级 B2',
      text32: '高中3年级',
      text33: '高中2年级',
      text34: '初中1年级',
      text35: '《WAL英语》高级 C1',
      text36: '大学四级',
      text37: '高中3年级',
      text38: '初中2年级',
      text39: '《WAL英语》高级 C2',
      text40: '大学六级',
      text41: '大学四级',
      text42: '初中3年级',
      text43: '小学英语：2011年，中国教育部，小学英语课程教学基本要求(试行)',
      text44: '初中英语：2008年，中国教育部，九年义务教育全日制初级中学英语教学大纲(试用修订版)',
      text45: '高中英语：2015年，中国教育部，全日制高中英语教学大纲(试用修订版)',
      text46: '大学四级：2016年，中国教育部，全国大学生英语四级考试大纲',
      text47: '大学六级：2016年，中国教育部，全国大学生英语六级考试大纲',
      text48: '教师理念',
      text49: '配合联合国教科文组织“世界语言地图”传播所创建的PRIC（Perform – Reinforce – Inform – Compare）母语教学法，与ICOC母语学习法搭配使用，能帮助教师在传统课堂中进行有效的多语言教学活动。',
      text50: '使用《全球说多语课程PRO》官方教材，教师通过PRIC的四大步骤——调整语言输入、设计语言任务、监督及反馈、评估及再调整，帮助学生理解、使用和检验语言摄入（Intake），更好的实现学生语言能力的提高。',
      text51: '教师用书（附教学PPT）',
      text52: '教师用书是专门为采用《全球说多语课程PRO》的教师量身设计的教学教材，内容全面覆盖课堂时间分配、教学流程梳理、本课所需口语和语法要点、授课时间和技巧、授课内容总结、学习创意作业分配与展示等环节，为教师提高备课及教学能力，帮助教师实现课堂高效率。',
      text53: '教学单词卡',
      text54: '数千张语言教学学习闪卡，通过数百种生活、工作场景将学习语日常生活联系起来，加深语言单词印象。本套教学单词闪卡供教师在课堂展示和课堂游戏辅助使用，提升学员对词汇与场景的理解，并为学员在语言学习中增加趣味性。',
      text55: '学习系统脚本手册',
      text56: '学习系统脚本手册涵盖学习系统的所有内容，包括核心课程、听力、口语、阅读、写作、语法、听说、测试等七大版块，为教师课堂授课之前，提供本课知识点的全景展示以及全面的学习评估，有助于引导学员快速融入各类学习场景并应用所学内容展开对话与交流。',
      text57: ''
    },
    childClass: {
      text01: '联合国教科文组织-全球说儿童多语实验班',
      text02: '2018年2月21日第十九个“国际母语日”之际，联合国教科文组织重申在学前儿童阶段推广以母语教育为基础的多语言教育的重要性。随后，联合国教科组织-全球说正式立项发起以“植根中国，通晓世界”为目标的“儿童多语教育与多元文化实践计划”。在多语言课程体系与多元文化体验活动中把优质教育的培养落到每个孩子的成长中，借助语言的力量去探索无边的世界，把儿童培养成面向未来世界的国际人。',
      text03: '在未来3年内，该计划将在联合国教科文组织世界语言地图项目下，普及和推广《全球说儿童多语课程》，以“联合国教科文组织-全球说儿童多语实验班”的形式在中国学前领域进行全新的教育实践，预计覆盖50,000名学前儿童...，为联合国教科文组织提供可在全球范围内复制的多语教育范本，让优质教育从幼儿时期贯穿到终身教育。',
      text04: '1.联合国教科文组织-全球说儿童英语实验班',
      text05: '2.联合国教科文组织-全球说儿童法语实验班',
      text06: '3.联合国教科文组织-全球说儿童西班牙语实验班',
      text07: '4.联合国教科文组织-全球说儿童汉语实验班',
      text08: '教学目标',
      text09: '培养掌握多种语言，了解多元文化的未来小公民。',
      text10: '尊重',
      text11: '引导孩子平等看待多元文化和价值观',
      text12: '勇气',
      text13: '培养孩子探索世界和面对未知的精神',
      text14: '自信',
      text15: '在语言与文化的习得中掌握跨文化理解力与核心素养力',
      text16: '创新',
      text17: '在多语言启蒙中建立多元的思考维度',
      text18: '包容',
      text19: '对世界多元文化与语言多样性的赏识能力',
      text20: '团结',
      text21: '发展个人全球观、未来公民意识',
      text22: '教学内容',
      text23: '语言学习：',
      text24: '通过单词、游戏、TPR活动、角色扮演、多元认知、故事绘本等游戏化教学形式，采用自然母语教学法和多媒体课件帮助儿童建立语言学习的兴趣，配套的智能互动学习系统将多语言课程还原成母语环境，学生可以在家庭与家长一起随时练习语感。',
      text25: '文化探索：',
      text26: '通过丰富的手工、音乐、舞蹈等活动元素，在饮食、建筑、服饰、习俗、音乐、艺术等方面设计了适合儿童行为认知的探索活动，一个月完成一个国家的文化探索，学生与老师合作完成的作品可以呈现在多元文化主题区域角和班级作品墙，提升学校的多元文化环境创设。语言与文化紧密相连，在世界文化探索课程中，儿童在老师的引导下了解不同国家文化的多样性，开阔国际视野，培养跨文化的理解力。',
      text27: '英国文化之旅',
      text28: '印度文化之旅',
      text29: '阿根廷文化之旅',
      text30: '联合国日',
      text31: '教学资源',
      text32: '学生资源包',
      text33: '教师资源包',
      text34: '文化资源包',
      text35: '绘本教材',
      text36: '教学形式',
      text37: '通过单词、游戏、TPR活动、角色扮演、多元认知、故事绘本等游戏化教学形式，采用自然母语教学法和多媒体课件帮助儿童建立语言学习的兴趣，让孩子建立对语言的认识，培养母语式外语学习思维方式，形成自然听、说、读的语言学习习惯，激发孩子的语言学习兴趣，培养语言使用习惯。',
      text38: '模块教学 ，由浅入深，灵活组合',
      text39: '联合国教科文组织总部（法国·巴黎）毕业典礼暨',
      text40: '联合国教科文组织-全球说 语言文化小大使游学团欧洲5国访问交流',
      text41: '如果您有关于“联合国教科文组织-全球说儿童多语实验班”项目的问题，请联系项目官员：',
      text42: '单词',
      text43: '学习词汇，把词汇放入场景中，让词汇变为有意义可理解的输入。',
      text44: 'TPR 活动',
      text45: '词汇-歌谣-TPR由静到动，内容难度逐渐加大，让儿童专注听力训练。',
      text46: '绘本 故事',
      text47: '故事教学场景多样化，词汇到短语到完整句子到篇章，在故事中融入品德教育',
      text48: '游戏',
      text49: '词汇放入句型中，通过游戏的形式，易理解，好玩又有趣。',
      text50: '多元 文化',
      text51: '跨学科教学，用心语言培养思维能力和创造能力。',
      text52: '角色 扮演',
      text53: '将句子融入生活场景中，用语言来表达思维。'
    },
    partner: {
      text01: '合作类别',
      text02: '查询'
    },
    download: {
      text01: '下载中心',
      text02: '使用说明书',
      text03: '全球说点读笔使用说明书',
      text04: '点读数据',
      text05: '2019-K1A3.0点读包',
      text06: '2019-K1B3.0点读包',
      text07: '2019-K2A3.0点读包',
      text08: '2019-K2B3.0点读包',
      text09: '2019-K3A3.0点读包',
      text10: '2019-K3B3.0点读包',
      text11: '2019-K1A2.0点读包',
      text12: '2019-K1B2.0点读包',
      text13: '2019-K2A2.0点读包',
      text14: '2019-K2B2.0点读包',
      text15: '2019-K3A2.0点读包',
      text16: '2019-K3B2.0点读包'
    },
    webResource: {
      text01: '全球说教师资源管理系统',
      text02: '全球说编辑器系统',
      text03: '全球说工作资源管理系统',
      text04: '全球说用户管理系统',
      text05: '酷语后台管理系统',
      text06: '全球说内容管理系统'
    }
  },
  learnCommonweal: {
    researchProject: {
      text01: '联合国教科文组织-全球说科研规划课题（2019-2020）',
      text02: '《儿童多语教育与多元文化实践计划》：2018年2月21日第十九个“国际母语日”之际，联合国教科文组织重申在学前儿童阶段推广以母语教育为基础的多语言教育的重要性。随后，联合国教科组织-全球说世界语言地图办公室正式立项发起以“植根中国，通晓世界”为目标的“儿童多语教育与多元文化实践计划”。在未来3年内，该计划以“联合国教科文组织-全球说儿童多语实验班”的形式在学前领域进行落地，为联合国教科文组织提供可在全球范围内复制的多语教育范本，让优质教育从幼儿时期贯穿到终身教育。',
      text03: '下载申请表',
      text04: '《基于母语教育的多语言和多元文化教育的未来小公民教育体系研究》：随着世界全球化和文化多元化的发展,不同文化之间的交流交融、互学互鉴日趋频繁,促进不同文化的和谐共生,相互理解、相互尊重、相互包容显得至关重要。在学前阶段普及多元文化认知和多语教育启蒙有助于塑造和培养孩子全球意识和开放的心态,了解人类文明进程和世界发展动态，能尊重世界多元文化的多样性和差异性，积极参与跨文化交流，理解人类命运共同体的内涵与价值等。因此联合国教科文组织——全球说世界语言地图项目办公室立项《基于母语教育的多语言和多元文化教育的未来小公民教育体系研究》，以全球说遍布世界各地的语言学习者为样本库，致力于为全球幼儿多语言学习启蒙和多元文化教育构建更科学、更全面和更具实践意义的教育体系研究范本。',
      text05: '《论利用网络空间进行多语言教育和多文化认同教育的可行性研究》：2003年，联合国教科文组织大会通过了《普及网络空间及促进并使用多种语言的建议书》，重点提出了加强世界语言的多样性，尤其是促进多语言在互联网上的发展倡议，此项倡议以互联网为载体，呼吁全球各界保护语言多样性，获得了各会员国广泛的支持和认同。以此为契机，联合国教科文组织——全球说世界语言地图项目办公室发起《论利用网络空间进行多语言教育和多文化认同教育的可行性研究》课题，助力多语言教育和多元文化认同教育在互联网时代的发展。',
      text06: '《儿童多语教育与多元文化实践计划》',
      text07: '子课题名称',
      text08: '课题完成期限',
      text09: '课题状态',
      text10: '学前教育领域多语（中/英/法/西）学科口语与应用能力教育教师专业发展研究',
      text11: '2020 年',
      text12: '进行中：接受个人/机构申请',
      text13: 'ICOC母语学习法与儿童表达方法研究',
      text14: '学前领域儿童多语言教学活动有效性策略的研究',
      text15: '学前儿童语言教学游戏领域的探索',
      text16: '学前儿童多语教学教案设计与探索',
      text17: '儿童早期第二外语沉浸式教学研究和课程体系研究',
      text18: '学前儿童法语学习与教学技巧的探索',
      text19: '学前儿童西班牙语学习与教学技巧的探索',
      text20: '《基于母语教育的多语言和多元文化教育的未来小公民教育体系研究》',
      text21: '多语言对话与多元文化素养的培养',
      text22: '全语言观念与儿童早期语言发展的探索',
      text23: '中国学龄前儿童多语言应用能力如何与国际接轨',
      text24: '儿童多语训练与文化课程的融合与创新',
      text25: '母语教育背景下的多语言培养体系的科学性探讨',
      text26: '全语言观念对可持续发展的重要性',
      text27: '全球背景下语言训练与文化素养培养的范例讨论（针对3-6岁学前教育）',
      text28: '中国学前儿童多语教学与多元文化教育对未来小公民的影响',
      text29: '《利用网络空间进行多语言教育和多文化认同教育的可行性研究》',
      text30: '互联网技术下的双师课堂教学实践',
      text31: '基于线上线下多媒体资源的儿童多语课堂教学环境设置',
      text32: 'ICTs模式支持下的多语教学（线上及线下）应用与实践范例',
      text33: '学前儿童语言教育与在线学习',
      text34: '微课与学前儿童语言教育教学模式的改革',
      text35: '教室与儿童多语言教育的结合',
      text36: '互联网空间的快速发展对学前儿童语言教育存在问题与影响初探',
      text37: 'ICTs模式与儿童语言教育的测评',
      text38: '国家“十三五”科研规划课题',
      text39: '《多语教育和多元文化传播的理念和实践》',
      text40: '随着历史的不断发展和社会的不断进步，多语教育和不同文化间的理解、尊重已经融合在不同国度的社会历史发展当中。在欧洲，培养学生掌握多种语言能力的教学理念贯穿在整个教育过程当中，这种能力已经成为欧洲学生顺利完成学业的基本保证。在北美洲，多语教育已经走入加拿大普通公民的家庭之中，多语教育和多元文化认识随着学校教育和社会教育而潜移默化地融入到人们的生活当中。亚洲许多国家也很早就考试重视多语教育，并以此作为衡量人们社会价值的一个尺度。以色列、印度、巴基斯坦、泰国等都是开展多语教育和多元文化普及的典型国家。《多语教育和多元文化传播的理念和实践》课题，根据“全球说”（Talkmate）多语教育和多元文化推广的实施情况，系统、科学的多语和多元文化教育的理论方法、实践方式，借此为世界多语教育和多元文化推广提供一个系统的、可借鉴的、理论与实践并存的途径。',
      text41: '《多语教育和多元文化传播的理念和实践》',
      text42: '2021 年',
      text43: '基于多元文化和多语教育的国际认知理解力研究',
      text44: '沉浸式校园多元文化环境构建',
      text45: '多语绘本在幼儿园语言领域教育活动中运用的行动研究',
      text46: '音乐歌曲引入语言教育的必要性',
      text47: '中国中小学多元文化和多语教育课程开发与设计探讨',
      text48: '《在线多语言教育教学研究》',
      text49: '《在线多语言教育教学研究》从提高国民语言素质着眼，聚焦教育语言服务，观照传统语言教育方式，响应联合国教科文组织“促进网络空间使用多语言建议书”，使用现代信息技术和网络技术嫁接多语言教育，进而优化我国的语言教育系统，提升传统语言教育的效能，为推动国家语言能力建设贡献智慧。',
      text50: '《在线多语言教育教学研究》',
      text51: '语音识别和概念地图技术支持多语言教育的实验研究',
      text52: '论在线多语课程与课堂学习的融合',
      text53: '在线丰富口音语料库对语言学习者语言能力培养的影响',
      text54: '构建多语言学习型网络社交平台的思考',
      text55: '多语言课程的在线MOOC教育探讨'
    },
    langProtection: {
      text01: '保护语言与保护专业化',
      text02: '全球说（talkmate）与联合国教科文组织就世界语言地图项目达成合作关系，现致力于打造多语言学习交流平台，执行搜集发掘和修复国内外濒危语言等工作。全球说深入欠发达地区，搜集了上千语种语言数据，并逐步创建了专业化语言保护体系，实现了语言保护管理人才从无到有、从有到专，为语言保护事业构建了专业基础。',
      text03: '下载申请表',
      text04: '语言保护范例——江永女书',
      text05: '国家级非物质文化遗产，世界上唯一的女性文字',
      text06: '女书是当今世界上发现的唯一的系统性女性文字，主要流传在湘、桂、粤交界的湖南省江永县，所以又名江永女书。',
      text07: '传奇女书',
      text08: '15',
      text09: '11',
      text10: '08',
      text11: '29',
      text12: '2017-05',
      text13: '2017-09',
      text14: '2017-11',
      text15: '“一带一路”国际合作高峰论坛',
      text16: '在“一带一路”国际高峰论坛期间，联合国教科文组织前任总干事博科娃从国务院副总理刘延东手中，接受了一份特殊的礼物——以女书书写的“文明交流互鉴”。',
      text17: '首届北京国际语言文化博览会',
      text18: '全球说与永州市代表在“首届国际语言文化博览会”上，举行《全球说—传奇女书》先导课程首发暨“全球说”与永州市合作备忘录签署仪式，并召开新闻发布会，共同推动“江永女书”方言文化的保护和传承工作，争取把女书纳入世界语言地图项目。',
      text19: '传奇女书亮相“首届北京国际语言文化博览会”，向社会展现了“江永女书”独特而神奇的魅力。会上，湖南江永女书传人现场书写女书并进行了精彩的表演。',
      text20: '《全球说——传奇女书》主题课程在首届北京国际语言文化博览会上发布，促进了“江永女书”方言文化的保护和传承，更助力江永女书申报世界非物质文化遗产。',
      text21: '《全球说——传奇女书》主题课程',
      text22: '在女书研究专家、清华大学赵丽明教授的指导 ，和“语保”中心 及“響應计划”发起人汪涵先生的鼎力协助下，与江永县相关专家及女书传人共同完成首部“江永女书”课程。',
      text23: '考察调研女书资源保护',
      text24: '2017年11月29日，联合国教科文组织信息与传播部门专家、世界语言地图项目负责人布得博格博士等一行5人前往永州市江永县，实地调研江永女书资源的保护工作。',
      text25: '全球说-传奇女书',
      text26: '《全球说-传奇女书》',
      text27: '中国语言国际化时尚化科技化的样本',
      text28: '由中国语言资源保护研究中心与「全球说」共同打造成套“中国方言文化系列课程”的首发课程《全球说-传奇女书》，作为「全球说」“中国方言文化系列课程”面向国际推广，推动中国文化走出去，保护和传承中华优秀传统文化不断探索、前进。',
      text29: '2017年9月，被编制成颇具时尚感的多媒体课程，在多语言学习平台——全球说上首发',
      text30: ''
    },
    langCompetition: {
      text01: '母语是通向世界的窗口',
      text02: '关于“2017-2018 Language Champion',
      text03: '2016年7月，联合国教科文组织和全球说建立联合伙伴关系，该关系的整体目标是增加语言多样性、促进世界发展。 基于多语言推广的方案，特别是网络空间并聚焦于语言多样性的记录、保存、学习和推广， 通过包容性的信息通信技术的应用，更好地应对发展中的挑战。 双方联合的工作将强化联合国教科文组织的《关于普及网络空间及提倡和使用多种语言的建议书》（2003）。',
      text04: '在2016至今的合作关系中，联合国教科文组织-全球说项目办公室进行了多项实践，包括举办联合国教科文-全球说“多语言冠军挑战赛”，目的是为全球青少年搭建一个多语言学习和跨文化交流的平台，提升青少年的全球视野和倡导语言多样性的意识，同时，办公室还重视语言公益事业的发展，包括与中国教育部及地方政府合作进行方言保护工作，其中具有代表性的项目为对湖南江永女书的保护。',
      text05: '为吸引更多年轻人了解方言保护并加入到其中，全球说与国内首屈一指的网络媒体平台——新浪微博合作，对多语言冠军挑战赛进行宣传。通过微博，主办方可以通过各种方法进行大赛与方言保护推广，并且即时与参赛者、关注者进行互动。',
      text06: '多语言冠军挑战赛',
      text07: '影响力',
      text08: '新浪微博教育榜热门TOPIC',
      text09: '6.5万人以视频的形式展示家乡的母语，覆盖国内千所大学，占据教育榜第1',
      text10: '话题的讨论量8.9万次',
      text11: '天天兄弟团、100+校园微博助力语言保护行动，提升赛事话题量，促进语言和文化多样性的发展',
      text12: '深度推广(17.12.1-18.2.13)',
      text13: '1月20日起，我们集中在线资源、品牌资源，通过微博故事和主题推广进行宣传活动，在整个网络范围推广大赛。推广期中，注册页访问量增加90000次，注册量增加18000，新增投稿视频11751件。数据表明，宣传推广取得了668%的成果。',
      text14: '用户分析',
      text15: '95后年轻女生为主要受众群',
      text16: '经分析，大赛关注者和参与者中女性和95后比例较大，并且拥有至少一种爱好、特长的全面发展用户较多。',
      text17: '年龄分布',
      text18: '精准覆盖多语言、多才艺用户',
      text19: '用户兴趣分配',
      text20: '突出',
      text21: '微博故事',
      text22: '曝光量高达1亿4千万.',
      text23: '微博话题页阅读量为1亿4千万，关注者达1.6万人，参与话题的讨论量达到8.9万次。',
      text24: '大赛志愿者达到5000名',
      text25: '5000名志愿者加入赛事志愿宣传服务，组织高校路演活动，覆盖全国百余所大学。',
      text26: ''
    }
  },
  news: []
}
